import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import isEmpty from "lodash.isempty";
import moment from 'moment';

import { messages as jobmessages, debtorStatusMessages, debtorStatusDescs, mainStatusText } from '../views/Job/Job.messages';
import { JOB_ENERGYTYPE } from '../services/job';


const InvoiceStatusInfo = (props) => {
    const lng = props.intl.formatMessage;
    const [invoiceStatusText, setInvoiceStatusText] = useState('');
    const dateNow = moment(new Date()).format('YYYY-MM-DD');
    const debtorStatusText = typeof debtorStatusMessages['statuscode' + props.job.debtor_statuscode] !== "undefined" && debtorStatusMessages['statuscode' + props.job.debtor_statuscode] !== "" ? lng(debtorStatusMessages['statuscode' + props.job.debtor_statuscode]) : '';
    let debtorStatusDesc = null;

    // sets statusdescriptions, if any are related to the job
    if (typeof debtorStatusDescs['statusdesc' + props.job.debtor_statuscode] !== "undefined" && debtorStatusDescs['statusdesc' + props.job.debtor_statuscode] !== "") {

        // Check if job status is cutoff warning and energytype is other than electricity or by default empty
        const nonElectricityCutOffWarning = (props.job.statuscode === 156 && !isEmpty(props.job.energytype) && props.job.energytype !== JOB_ENERGYTYPE.ELECTRICITY);

        // As long as job is other than non electricity cutoff warning, display the status description
        if (!nonElectricityCutOffWarning) {
            debtorStatusDesc = lng(debtorStatusDescs['statusdesc' + props.job.debtor_statuscode]);
        }
    }

    useEffect(() => {
        // Set invoice status based on job status
        switch (props.job.job_main_statuscode) {
            case 0:
                // If duedate is due show status 'late'
                if (props.job.paydate !== undefined && props.job.paydate < dateNow) {
                    setInvoiceStatusText(lng(mainStatusText.late));
                } else {
                    setInvoiceStatusText(lng(mainStatusText.invoice));
                }
                break;
            case 1:
                setInvoiceStatusText(lng(mainStatusText.reminder));
                break;
            case 2:
                setInvoiceStatusText(lng(mainStatusText.collection));
                break;
            case 101:
                setInvoiceStatusText(lng(mainStatusText.paid));
                break;
        }

    }, [props.job]);


    return (
        <>
            <span className='label'>{lng(jobmessages.statusLabel)}</span>
            <span className='float-end text-end'> {invoiceStatusText} </span>
            {/* Show debtor status text only if it's not the same as invoice main status text */}
            {invoiceStatusText !== debtorStatusText && (
                <p className='mt-3'>
                    {debtorStatusText}
                </p>
            )}

            {/* Show additional status description, if available */}
            {debtorStatusDesc !== null && (
                <div id='job-statusdesc-warning'>
                    <p >{debtorStatusDesc}</p>
                </div>
            )}
        </>
    );
};

InvoiceStatusInfo.propTypes = {
    'intl': PropTypes.object.isRequired,
    'job': PropTypes.object
};

export default InvoiceStatusInfo;